var _style, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#79B551;}\n\t.st2{display:inline;fill:#3F5C2C;}\n\t.st3{display:inline;}\n\t.st4{fill:#3F5C2C;}\n\t.st5{display:inline;fill:#EDBB45;}\n\t.st6{fill:#7B6F20;}\n\t.st7{fill:#D45136;}\n\t.st8{fill:none;stroke:#C10E1A;stroke-width:0.9316;stroke-miterlimit:10;}\n\t.st9{fill:#6A2C20;}\n\t.st10{display:inline;fill:#81BC5F;}\n\t.st11{fill:#272425;}\n\t.st12{display:inline;fill:#EBB23F;}\n\t.st13{display:inline;fill:#272425;}\n\t.st14{display:inline;fill:#DE5835;}\n\t.st15{fill:#C6461A;}\n\t.st16{fill:#FFFFFF;}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:#7F7F7F;}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:#747270;}\n\t.st19{fill:#6F6F6E;}\n\t.st20{fill:#3E3E3D;}\n\t.st21{fill:#9FBE37;}\n\t.st22{fill:#B6C938;}\n\t.st23{fill:#C4C4C3;}\n\t.st24{fill:#EBB23F;}\n\t.st25{opacity:0.3;}\n\t.st26{fill:#585857;}\n\t.st27{fill:#848484;}\n\t.st28{fill:#D54242;}\n\t.st29{display:inline;opacity:0.26;fill:#C3C0C0;}\n\t.st30{fill:#3B3B3B;}\n\t.st31{fill:#B4842E;}\n\t.st32{fill:#C9374D;}\n\t.st33{opacity:0.26;fill:#C3C0C0;}\n\t.st34{fill:#676767;}\n\t.st35{fill:#625F5F;}\n\t.st36{display:inline;fill:#AA0011;}\n\t.st37{fill:#7F7F7F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Serie1-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 150,
    cy: 150,
    r: 132.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "mouth_00000090998842306167665670000009011761131000344705_",
    className: "st2",
    d: "M199.86,188.77c3.05-2.17,7.09,1,5.57,4.43 c-8.05,18.15-29.83,31.15-55.43,31.15c-25.6,0-47.38-13.01-55.42-31.15c-1.52-3.43,2.52-6.6,5.57-4.43 c12.08,8.6,29.94,14.04,49.85,14.04C169.92,202.81,187.77,197.37,199.86,188.77z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.47,149.71c-0.53,0-1.07-0.06-1.61-0.2c-3.56-0.88-5.73-4.49-4.85-8.05 c3.95-15.91,15.02-26.6,27.55-26.6c12.53,0,23.61,10.69,27.56,26.6c0.88,3.56-1.29,7.16-4.85,8.05 c-3.56,0.88-7.16-1.29-8.05-4.85c-2.41-9.72-8.44-16.52-14.66-16.52c-6.21,0-12.24,6.79-14.66,16.52 C180.16,147.69,177.45,149.71,174.47,149.71z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M83.33,149.71c-0.53,0-1.07-0.06-1.61-0.2c-3.56-0.88-5.73-4.49-4.85-8.05 c3.95-15.91,15.02-26.6,27.55-26.6c12.53,0,23.61,10.69,27.56,26.6c0.88,3.56-1.29,7.16-4.85,8.05 c-3.56,0.88-7.16-1.29-8.05-4.85c-2.41-9.72-8.44-16.52-14.66-16.52c-6.21,0-12.24,6.79-14.66,16.52 C89.02,147.69,86.31,149.71,83.33,149.71z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x32_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 150,
    cy: 150,
    r: 132.13
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 198,
    cy: 139.26,
    rx: 17.47,
    ry: 25.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 102,
    cy: 139.26,
    rx: 17.47,
    ry: 25.33
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.06,208.92H97.94c-3.68,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h104.11c3.68,0,6.65,2.98,6.65,6.65 S205.73,208.92,202.06,208.92z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_00000181777064938997379020000010347497856165210518_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 150,
    cy: 150,
    r: 132.13
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M150,200.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.42,223.48L201.42,223.48c-0.75,0-1.49-0.26-2.03-0.76c-8.86-7.99-27.65-13.5-49.39-13.5 c-21.74,0-40.53,5.51-49.39,13.5c-0.55,0.49-1.28,0.76-2.03,0.76h0c-1.89,0-3.31-1.65-2.98-3.44 c3.33-18.01,26.42-31.96,54.4-31.96c27.99,0,51.07,13.95,54.4,31.96C204.73,221.83,203.32,223.48,201.42,223.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.46,131.58l14.13-14.13c2.6-2.6,2.6-6.81,0-9.41c-2.6-2.6-6.81-2.6-9.41,0l-14.13,14.13l-14.13-14.13 c-2.6-2.6-6.81-2.6-9.41,0c-2.6,2.6-2.6,6.81,0,9.41l14.13,14.13l-14.13,14.13c-2.6,2.6-2.6,6.81,0,9.41c1.3,1.3,3,1.95,4.71,1.95 c1.7,0,3.41-0.65,4.71-1.95l14.13-14.13l14.13,14.13c1.3,1.3,3,1.95,4.71,1.95s3.41-0.65,4.71-1.95c2.6-2.6,2.6-6.81,0-9.41 L209.46,131.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M90.54,131.58l-14.13-14.13c-2.6-2.6-2.6-6.81,0-9.41c2.6-2.6,6.81-2.6,9.41,0l14.13,14.13l14.13-14.13 c2.6-2.6,6.81-2.6,9.41,0c2.6,2.6,2.6,6.81,0,9.41l-14.13,14.13l14.13,14.13c2.6,2.6,2.6,6.81,0,9.41c-1.3,1.3-3,1.95-4.71,1.95 c-1.7,0-3.41-0.65-4.71-1.95l-14.13-14.13l-14.13,14.13c-1.3,1.3-3,1.95-4.71,1.95s-3.41-0.65-4.71-1.95c-2.6-2.6-2.6-6.81,0-9.41 L90.54,131.58z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Serie2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__00000028296184420165559360000010988092321514644665_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M150,14.42c74.88,0,135.58,60.7,135.58,135.58v0c0,74.88-60.7,135.58-135.58,135.58l0,0 c-74.88,0-135.58-60.7-135.58-135.58v0C14.42,75.12,75.12,14.42,150,14.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M74.47,133.07c13.73-24.39,32.47-42.1,46.18-42.1s18.14,17.72,12.16,42.1h1.26 c10.51-29.3,6.7-52.32-9.3-52.32c-16,0-38.41,23.02-51.58,52.32H74.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.28,133.07c13.73-24.39,32.47-42.1,46.18-42.1s18.14,17.72,12.16,42.1h1.26 c10.51-29.3,6.7-52.32-9.3-52.32c-16,0-38.41,23.02-51.58,52.32H161.28z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M220.13,168.04c-23.19,26.17-63.31,52.43-91.14,52.43c-28.71,0-48.84-23.32-49.81-52.43l-2.06-0.37 c-1.49,30.82,13.87,63.28,47.36,63.28c33.49,0,75.07-32.46,98.49-63.28L220.13,168.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__00000019674269809918460360000017730632295068018605_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150,285.58L150,285.58c-74.88,0-135.58-60.7-135.58-135.58v0c0-74.88,60.7-135.58,135.58-135.58h0 c74.88,0,135.58,60.7,135.58,135.58v0C285.58,224.88,224.88,285.58,150,285.58z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M80.37,92.45c-5.98,24.39-1.55,42.1,12.16,42.1c13.71,0,32.46-17.72,46.18-42.1h1.26 c-13.17,29.3-35.58,52.32-51.58,52.32c-16,0-19.81-23.02-9.3-52.32H80.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M167.18,92.45c-5.98,24.39-1.55,42.1,12.16,42.1s32.46-17.72,46.18-42.1h1.26 c-13.17,29.3-35.58,52.32-51.58,52.32c-16,0-19.81-23.02-9.3-52.32H167.18z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M234.37,199.26c-0.98,2.42-39.55,4.39-86.15,4.39c-46.6,0-83.58-1.97-82.6-4.39 c0.98-2.42,39.55-4.39,86.14-4.39C198.37,194.87,235.35,196.83,234.37,199.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33__00000035494959816029132070000015737836845175973281_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M14.42,150c0-74.88,60.7-135.58,135.58-135.58l0,0c74.88,0,135.58,60.7,135.58,135.58v0 c0,74.88-60.7,135.58-135.58,135.58l0,0C75.12,285.58,14.42,224.88,14.42,150"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "217.46,233.47 218.81,212.03 209.32,191.6 195.23,179.86 169.24,176.29 134.58,187.52  103.83,213.05 87.26,233.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M177.01,242.17l1.69-0.85c0.39-16.34-6.08-27.2-18.47-27.2c-12.46,0-27.82,11-40.68,27.5l0.3,0.54H177.01z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "90.54,231.52 80.11,242.66 217.18,242.66 216.72,231.52  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M198.34,179.83h-46.59c-3.48,3.75-7.71,7.06-12.2,9.42c-3.85,2.03-7.77,3.67-11.7,5.13h82.02 C205.49,189.94,201.29,185.3,198.34,179.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.96,242.66c18.62-24.51,59.04-59.96,89.91-59.96c30.88,0,42.65,35.45,41.46,59.96h2.85 c8.9-29.45-4.13-70.23-40.16-70.23c-36.03,0-82.02,40.78-96.91,70.23H82.96z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M225.53,104.16c-13.73,24.39-32.47,42.1-46.19,42.1s-18.14-17.72-12.16-42.1h-1.26 c-10.51,29.3-6.7,52.32,9.3,52.32c16,0,38.41-23.02,51.58-52.32H225.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M138.72,104.16c-13.73,24.39-32.47,42.1-46.18,42.1s-18.14-17.72-12.16-42.1H79.1 c-10.51,29.3-6.7,52.32,9.3,52.32c16,0,38.41-23.02,51.58-52.32H138.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.3,56.82c7.09,8.24,11.52,16.24,9.91,17.87c-1.61,1.64-8.67-3.71-15.75-11.95 c-7.09-8.24-11.52-16.24-9.91-17.87C123.16,43.23,130.21,48.58,137.3,56.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M178.16,56.93c-6.77,8.5-10.9,16.66-9.23,18.23c1.67,1.57,8.52-4.04,15.29-12.53 c6.77-8.5,10.9-16.66,9.23-18.23C191.78,42.82,184.93,48.43,178.16,56.93z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_x34_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M212.47,112.51h-40.13c-0.63-7.86-10.51-14.1-22.6-14.1c-8.11,0-15.23,2.81-19.22,7.03l13.52,13.53 c1.94-0.29,3.93-0.44,5.95-0.44c22.31,0,40.51,18.2,40.51,40.51c0,2.02-0.15,4.01-0.44,5.95l32.23,32.23 c2.14-2.36,3.45-5.49,3.45-8.91v-62.52C225.75,118.49,219.78,112.51,212.47,112.51L212.47,112.51z M127,112.51l8.65,8.65 c-6.62,2.52-12.42,6.74-16.86,12.11l-29.1-29.1c0.82-0.76,1.91-1.22,3.1-1.22h19.24c2.51,0,4.57,2.06,4.57,4.57v0.68 c0,1.98-1.27,3.67-3.04,4.31H127L127,112.51z M187.88,173.39l27.81,27.81c-1.03,0.26-2.11,0.4-3.21,0.4h-25.36l-11.34-11.34 C181.14,185.81,185.36,180.01,187.88,173.39L187.88,173.39z M87.43,112.51l27.06,27.06c-3.19,5.78-5,12.42-5,19.46 c0,22.31,18.2,40.51,40.51,40.51c7.05,0,13.68-1.82,19.47-5l7.04,7.05H87.53c-7.31,0-13.28-5.98-13.28-13.28v-62.52 C74.24,118.52,80.17,112.57,87.43,112.51L87.43,112.51z M158.28,112.51L158.28,112.51h-16.18c-1.11-0.9-1.82-2.28-1.82-3.81 c0-2.7,2.21-4.91,4.91-4.91h10c2.7,0,4.91,2.21,4.91,4.91C160.09,110.23,159.38,111.61,158.28,112.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M150,193.92c5.48,0,10.67-1.27,15.29-3.54l-4.78-4.78c-3.26,1.3-6.8,2.01-10.51,2.01 c-15.73,0-28.56-12.83-28.56-28.56c0-3.71,0.71-7.26,2.01-10.51l-4.78-4.78c-2.27,4.62-3.54,9.81-3.54,15.29 C115.12,178.25,130.79,193.92,150,193.92L150,193.92z M171.77,186.25c5.48-4.4,9.62-10.4,11.67-17.3l-5.26-5.25 c-1.21,7.33-5.23,13.73-10.91,18.06L171.77,186.25L171.77,186.25z M184.87,159.79l-7-7c-2.41-10.73-10.89-19.2-21.62-21.61l-7-7 c0.25-0.01,0.49-0.01,0.74-0.01c19.21,0,34.88,15.67,34.88,34.87C184.88,159.29,184.87,159.54,184.87,159.79L184.87,159.79z  M140.09,125.6c-6.89,2.05-12.9,6.19-17.3,11.67l4.5,4.49c4.33-5.68,10.73-9.7,18.06-10.91L140.09,125.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M150,16.87C76.47,16.87,16.87,76.47,16.87,150c0,73.53,59.61,133.13,133.13,133.13 c73.53,0,133.13-59.61,133.13-133.13C283.13,76.47,223.53,16.87,150,16.87L150,16.87z M80.88,66.4L80.88,66.4 C99.65,50.87,123.73,41.53,150,41.53c59.91,0,108.47,48.56,108.47,108.47c0,26.27-9.34,50.35-24.87,69.12L80.88,66.4L80.88,66.4z  M219.12,233.6L219.12,233.6c-18.77,15.53-42.85,24.87-69.12,24.87c-59.9,0-108.47-48.56-108.47-108.47 c0-26.26,9.34-50.34,24.87-69.11L219.12,233.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "serie3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__00000065761002362706189130000005174774378179269539_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M258.43,85.83l-70.32-56.8h-76.21l-70.32,56.8c0,0,5.06,128.7,108.43,185.15 C253.35,214.53,258.43,85.83,258.43,85.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M183.82,39.49h-67.65L53.71,89.93l0.07,1.83c0.04,1.15,1.25,28.44,13.41,62.07 c11.27,31.16,34.48,73.63,81.06,99.08l1.75,0.96l1.75-0.96c46.58-25.45,69.8-67.92,81.05-99.08 c12.17-33.64,13.37-60.93,13.41-62.07l0.08-1.83L183.82,39.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M241.59,92.21l-59.4-47.98h-64.37L58.41,92.21c0,0,4.27,108.72,91.58,156.41 C237.31,200.94,241.59,92.21,241.59,92.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M64.58,153.09c0,1.71-1.38,3.09-3.07,3.09c-1.72,0-3.09-1.38-3.09-3.09c0-1.71,1.38-3.09,3.09-3.09 C63.21,150,64.58,151.38,64.58,153.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M241.59,153.09c0,1.71-1.39,3.09-3.09,3.09c-1.71,0-3.09-1.38-3.09-3.09c0-1.71,1.38-3.09,3.09-3.09 C240.2,150,241.59,151.38,241.59,153.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M100.38,218.47c0,1.71-1.36,3.09-3.07,3.09c-1.72,0-3.09-1.38-3.09-3.09c0-1.71,1.37-3.09,3.09-3.09 C99.02,215.37,100.38,216.75,100.38,218.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M205.79,218.47c0,1.71-1.39,3.09-3.1,3.09c-1.71,0-3.09-1.38-3.09-3.09c0-1.71,1.38-3.09,3.09-3.09 C204.39,215.37,205.79,216.75,205.79,218.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M50.89,89.27c0,1.71-1.39,3.1-3.1,3.1c-1.71,0-3.09-1.38-3.09-3.1c0-1.71,1.39-3.08,3.09-3.08 C49.49,86.18,50.89,87.56,50.89,89.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M255.3,89.27c0,1.71-1.39,3.1-3.09,3.1c-1.7,0-3.1-1.38-3.1-3.1c0-1.71,1.41-3.08,3.1-3.08 C253.91,86.18,255.3,87.56,255.3,89.27z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M153.08,262.52c0,1.72-1.38,3.09-3.08,3.09c-1.71,0-3.1-1.38-3.1-3.09c0-1.7,1.39-3.08,3.1-3.08 C151.7,259.45,153.08,260.83,153.08,262.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M117.01,34.44c0,1.7-1.38,3.08-3.09,3.08c-1.7,0-3.07-1.38-3.07-3.08c0-1.71,1.37-3.1,3.07-3.1 C115.63,31.33,117.01,32.73,117.01,34.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M189.16,34.44c0,1.7-1.39,3.08-3.09,3.08c-1.7,0-3.09-1.38-3.09-3.08c0-1.71,1.39-3.1,3.09-3.1 C187.78,31.33,189.16,32.73,189.16,34.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M58.87,91.64l163.28,76.08c4.02-8.93,7.2-17.69,9.72-25.89L82.76,72.35L58.87,91.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M214.24,183.5c2.27-4.1,4.38-8.2,6.3-12.27L58.41,95.69c0.28,3.34,0.88,8.95,2.11,16.19L214.24,183.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M223.27,77.39c-2.08,22.2-15.29,113.79-94.01,157.64c6.33,4.89,13.23,9.45,20.73,13.55 c87.32-47.67,91.59-156.4,91.59-156.4L223.27,77.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "140.26,201.6 93.67,173.03 107.12,151.07 134.41,167.8 204.17,81.2 224.22,97.35  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__00000136376178972272156300000010253557407462082237_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M259.48,85.2l-71-57.36h-76.96l-71,57.36c0,0,5.1,129.98,109.48,186.96 C254.37,215.17,259.48,85.2,259.48,85.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M184.16,38.4h-68.32L52.77,89.35l0.07,1.84c0.04,1.15,1.25,28.71,13.54,62.68 c11.37,31.47,34.81,74.36,81.86,100.05l1.76,0.96l1.77-0.96c47.05-25.69,70.49-68.58,81.86-100.05 c12.29-33.97,13.49-61.53,13.54-62.68l0.07-1.84L184.16,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M242.49,91.64L182.51,43.2h-65.01L57.51,91.64c0,0,4.32,109.8,92.49,157.94 C238.17,201.45,242.49,91.64,242.49,91.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M63.75,153.12c0,1.72-1.39,3.11-3.11,3.11c-1.72,0-3.12-1.39-3.12-3.11c0-1.73,1.4-3.12,3.12-3.12 C62.36,150,63.75,151.4,63.75,153.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M242.49,153.12c0,1.72-1.39,3.11-3.12,3.11c-1.72,0-3.11-1.39-3.11-3.11c0-1.73,1.4-3.12,3.11-3.12 C241.09,150,242.49,151.4,242.49,153.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M99.92,219.14c0,1.72-1.4,3.12-3.12,3.12c-1.72,0-3.12-1.4-3.12-3.12c0-1.72,1.4-3.12,3.12-3.12 C98.51,216.02,99.92,217.42,99.92,219.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M206.33,219.14c0,1.72-1.4,3.12-3.11,3.12c-1.73,0-3.12-1.4-3.12-3.12c0-1.72,1.39-3.12,3.12-3.12 C204.93,216.02,206.33,217.42,206.33,219.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M49.9,88.68c0,1.73-1.39,3.12-3.12,3.12c-1.71,0-3.11-1.4-3.11-3.12c0-1.72,1.4-3.12,3.11-3.12 C48.51,85.56,49.9,86.95,49.9,88.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M256.33,88.68c0,1.73-1.4,3.12-3.12,3.12c-1.71,0-3.12-1.4-3.12-3.12c0-1.72,1.4-3.12,3.12-3.12 C254.93,85.56,256.33,86.95,256.33,88.68z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M153.12,263.64c0,1.72-1.39,3.12-3.12,3.12c-1.72,0-3.12-1.4-3.12-3.12c0-1.72,1.4-3.12,3.12-3.12 C151.73,260.52,153.12,261.92,153.12,263.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M116.69,33.3c0,1.72-1.39,3.12-3.12,3.12c-1.72,0-3.12-1.4-3.12-3.12c0-1.72,1.4-3.12,3.12-3.12 C115.29,30.18,116.69,31.58,116.69,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M189.55,33.3c0,1.72-1.4,3.12-3.12,3.12c-1.73,0-3.12-1.4-3.12-3.12c0-1.72,1.39-3.12,3.12-3.12 C188.15,30.18,189.55,31.58,189.55,33.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M57.98,91.07l164.89,76.83c4.05-9.03,7.26-17.86,9.8-26.14L82.1,71.59L57.98,91.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M214.86,183.84c2.31-4.14,4.43-8.28,6.36-12.39L57.51,95.16c0.29,3.38,0.89,9.05,2.14,16.35 L214.86,183.84z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M224,76.69c-2.1,22.42-15.46,114.9-94.94,159.17c6.4,4.95,13.35,9.56,20.95,13.71 c88.17-48.15,92.49-157.95,92.49-157.95L224,76.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M210.13,153.46c0,3.44-2.79,6.24-6.23,6.24H97.99c-3.45,0-6.23-2.79-6.23-6.24V82.92 c0-3.45,2.79-6.24,6.23-6.24H203.9c3.44,0,6.23,2.79,6.23,6.24V153.46z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.68,
    y: 82.42,
    className: "st16",
    width: 106.53,
    height: 71.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M218.42,166.43c0,1.82-1.47,3.29-3.29,3.29H86.76c-1.82,0-3.29-1.47-3.29-3.29v-6.3 c0-1.81,1.47-3.29,3.29-3.29h128.37c1.82,0,3.29,1.47,3.29,3.29V166.43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.77,
    y: 156.84,
    className: "st27",
    width: 32.34,
    height: 6.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M150.96,114.27h-7.66c0,0,0,9.93,0,12.28c0,2.35,4.19,6.86,7.66,6.86h0h0c3.47,0,7.66-4.51,7.66-6.86 c0-2.35,0-12.28,0-12.28H150.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M150.97,133.73L150.97,133.73c-3.68,0-7.98-4.75-7.98-7.18v-12.6h15.95v12.6 C158.94,128.98,154.64,133.73,150.97,133.73z M143.63,114.58v11.96c0,2.16,4.03,6.54,7.33,6.54h0.01 c3.3,0,7.34-4.38,7.34-6.54v-11.96H143.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M136.38,150.26h29.56l-0.02-1.02l3.29-17.49c-3.44-2.32-7.56-4.27-10.58-5.89c0,0-3.14,4.99-7.39,4.99 c-5.2,0-7.93-4.99-7.93-4.99c-3.02,1.62-7.62,3.82-11.07,6.14l4.3,15.47L136.38,150.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M165.94,150.58h-29.56c-0.09,0-0.17-0.03-0.23-0.1c-0.06-0.07-0.09-0.15-0.08-0.24l0.15-2.74 l-4.28-15.42c-0.04-0.13,0.02-0.27,0.13-0.35c2.6-1.75,5.78-3.4,8.6-4.86c0.9-0.46,1.75-0.9,2.5-1.3 c0.15-0.09,0.35-0.03,0.43,0.12c0.02,0.04,2.7,4.82,7.64,4.82c4.03,0,7.09-4.79,7.12-4.84c0.09-0.14,0.27-0.19,0.42-0.11 c0.74,0.39,1.55,0.81,2.39,1.25c2.63,1.36,5.6,2.9,8.22,4.66c0.1,0.07,0.16,0.2,0.13,0.32l-3.28,17.46l0.02,0.99 c0,0.08-0.04,0.17-0.09,0.22C166.11,150.54,166.03,150.58,165.94,150.58z M136.71,149.94h28.9l-0.02-0.69 c0-0.03,0-0.05,0-0.07l3.25-17.29c-2.54-1.69-5.42-3.19-7.98-4.51c-0.75-0.39-1.47-0.76-2.15-1.12 c-0.72,1.04-3.62,4.89-7.49,4.89c-4.67,0-7.38-3.81-8.04-4.88c-0.68,0.36-1.44,0.75-2.23,1.17c-2.73,1.4-5.81,3-8.35,4.69 l4.23,15.25c0.01,0.03,0.02,0.06,0.01,0.1L136.71,149.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M163.26,109.31c-0.4-0.15-0.73,0-1,0.27c0.18-1.43,0.29-2.96,0.29-4.61c0-13.64-11.4-12.9-11.4-12.9 c-7.57,0.32-12.68,3.63-12.68,14.6c0,0.93,0.07,1.83,0.17,2.7c-0.22-0.13-0.47-0.18-0.75-0.07 c-1.17,0.44-0.64,3.8,0.66,5.31c1.26,1.46,1.81,0.96,1.86,0.92c2.66,5.66,7.5,8.94,10.74,8.94c3.21,0,7.38-2.76,9.68-8.88 c0.2,0.1,0.76,0.19,1.77-0.98C163.9,113.11,164.43,109.76,163.26,109.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M151.15,124.8c-3.21,0-8.08-3.1-10.89-8.84c-0.06,0.01-0.11,0.01-0.18,0.01 c-0.52,0-1.11-0.39-1.77-1.15c-1.02-1.18-1.64-3.48-1.3-4.82c0.17-0.64,0.51-0.9,0.76-1c0.17-0.06,0.33-0.08,0.49-0.08 c-0.08-0.75-0.12-1.51-0.12-2.25c0-9.94,4.01-14.54,12.98-14.92c0,0,0.12-0.01,0.32-0.01c1.91,0,11.42,0.64,11.42,13.23 c0,1.37-0.07,2.71-0.21,4c0.22-0.07,0.47-0.05,0.71,0.03c0.27,0.1,0.61,0.35,0.77,1c0.34,1.35-0.29,3.65-1.3,4.82 c-0.65,0.76-1.25,1.15-1.76,1.15c-0.02,0-0.04,0-0.06,0C158.64,122.07,154.37,124.8,151.15,124.8z M140.51,115l0.18,0.41 c2.58,5.47,7.34,8.74,10.45,8.74c3.05,0,7.13-2.68,9.38-8.67l0.12-0.33l0.32,0.16c0.02,0.01,0.05,0.02,0.11,0.02 c0.15,0,0.56-0.09,1.28-0.92c0.96-1.11,1.42-3.23,1.16-4.25c-0.06-0.2-0.16-0.47-0.37-0.55c-0.23-0.09-0.43-0.02-0.66,0.19 l-0.66,0.66l0.11-0.92c0.19-1.46,0.28-2.99,0.28-4.56c0-11.98-8.97-12.59-10.78-12.59c-0.17,0-0.28,0.01-0.29,0.01 c-8.56,0.36-12.38,4.77-12.38,14.28c0,0.87,0.06,1.77,0.17,2.67l0.09,0.66l-0.57-0.35c-0.16-0.1-0.31-0.11-0.48-0.05 c-0.2,0.08-0.31,0.34-0.36,0.55c-0.26,1.02,0.2,3.15,1.15,4.25c0.73,0.83,1.13,0.92,1.28,0.92c0.08,0,0.12-0.02,0.12-0.02 L140.51,115z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M162.29,99.84c-1.25-2.88-2.93-4.72-4.65-5.89c-0.23-0.29-1.41-2.77-2.91-3.67 c0,0,0.76,1.06-0.04,1.78c0,0-0.61-1.24-1.83-1.88c-1.22-0.64-1.68-1.52-1.68-1.52s-0.49,1.81-1.33,1.99 c0,0-0.07-0.22-0.24-1.07c0,0-0.45,1.49-4.26,3.08c-0.18,0.07-0.37,0.14-0.55,0.22c-0.04,0.02-0.08,0.04-0.13,0.05h0.01 c-2.15,0.97-4.4,2.82-5.98,6.38c-0.8,1.8-0.9,2.95-1.01,4.59l0,0c-0.05,0.66,0.11,1.68,0.22,2.26 c0.02,0.12,0.07,0.43,0.09,0.57c0.31,2.5,1.38,4.84,1.38,4.84s0.32-1.26,0.69-1.43c0.23-0.1-0.95-3-0.59-5.62h0 c0.28-1.29,1.4-4.37,2.25-4.74c2.29-0.98,3.98,2.46,8.85,2.51l0,0c0.01,0,0.01,0,0.02,0c0,0,0.01,0,0.02,0l0,0 c4.87-0.05,6.54-3.44,8.85-2.51c2.77,1.12,2.31,9.49,2.52,9.6c0.37,0.17,0.37,1.37,0.37,1.37S165.02,106.13,162.29,99.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M139.38,111.89c-0.13,0-0.24-0.08-0.29-0.19c-0.04-0.1-1.09-2.41-1.41-4.93 c-0.02-0.13-0.07-0.43-0.09-0.55c-0.07-0.35-0.29-1.54-0.22-2.34c0-0.01,0-0.01,0-0.02c0.11-1.71,0.22-2.86,1.03-4.67 c1.38-3.11,3.43-5.3,6.09-6.51c0.02-0.02,0.04-0.03,0.06-0.04l0.14-0.05c0.18-0.08,0.37-0.16,0.56-0.22 c3.55-1.48,4.05-2.86,4.05-2.87c0.04-0.14,0.18-0.23,0.32-0.23c0.15,0,0.27,0.11,0.3,0.25c0.07,0.3,0.11,0.52,0.15,0.67 c0.37-0.35,0.69-1.18,0.81-1.6c0.03-0.13,0.14-0.22,0.27-0.24c0.13-0.01,0.26,0.06,0.31,0.17c0.01,0,0.43,0.8,1.53,1.38 c0.83,0.44,1.39,1.12,1.7,1.57c0.13-0.46-0.22-0.97-0.24-1c-0.08-0.12-0.07-0.29,0.02-0.4c0.11-0.11,0.27-0.13,0.4-0.05 c1.27,0.76,2.28,2.51,2.77,3.36c0.08,0.14,0.16,0.28,0.21,0.35c2,1.38,3.58,3.4,4.71,5.99c2.76,6.36,0.16,11,0.04,11.2 c-0.07,0.13-0.22,0.19-0.36,0.15c-0.14-0.04-0.23-0.17-0.23-0.31c0-0.47-0.09-0.99-0.19-1.09c-0.22-0.1-0.22-0.22-0.26-1.38 c-0.08-2.03-0.28-7.41-2.24-8.2c-0.23-0.1-0.46-0.14-0.7-0.14c-0.7,0-1.42,0.4-2.31,0.91c-1.37,0.77-3.07,1.73-5.69,1.76 c-0.02,0-0.03,0-0.04,0c0,0-0.01,0-0.02,0l0,0c-2.63-0.03-4.34-0.99-5.72-1.78c-0.89-0.51-1.61-0.91-2.3-0.91 c-0.24,0-0.48,0.05-0.71,0.15c-0.61,0.26-1.7,2.93-2.05,4.45c0,0.01,0,0.02,0,0.04c-0.23,1.68,0.19,3.5,0.44,4.58 c0.2,0.85,0.27,1.14-0.04,1.28c-0.12,0.08-0.37,0.66-0.51,1.22c-0.03,0.13-0.14,0.23-0.28,0.24 C139.39,111.88,139.38,111.89,139.38,111.89z M138,103.95c-0.04,0.57,0.08,1.48,0.21,2.14c0.03,0.13,0.08,0.44,0.11,0.59 c0.19,1.56,0.69,3.08,1.03,3.96c0.11-0.27,0.25-0.53,0.42-0.68c-0.02-0.15-0.09-0.42-0.15-0.67 c-0.26-1.11-0.69-2.96-0.47-4.75c0-0.03,0-0.05,0-0.08c0.19-0.88,1.33-4.48,2.44-4.96c0.32-0.14,0.63-0.21,0.96-0.21 c0.86,0,1.67,0.46,2.61,0.99c1.31,0.75,2.95,1.67,5.41,1.69c0,0,0.01,0,0.02,0c2.47-0.02,4.1-0.94,5.42-1.68 c0.94-0.53,1.75-0.98,2.62-0.98c0.32,0,0.63,0.06,0.94,0.18c2.34,0.94,2.54,6.23,2.64,8.77c0.02,0.37,0.02,0.75,0.04,0.93 c0.11,0.1,0.19,0.23,0.25,0.4c0.6-1.66,1.39-5.24-0.52-9.62c-1.09-2.5-2.61-4.44-4.52-5.74c-0.02-0.02-0.06-0.04-0.07-0.07 c-0.06-0.08-0.13-0.2-0.29-0.46c-0.35-0.6-0.97-1.68-1.74-2.47c0.01,0.37-0.11,0.75-0.46,1.07 c-0.08,0.07-0.18,0.1-0.28,0.08c-0.1-0.02-0.18-0.08-0.22-0.17c-0.01-0.01-0.59-1.16-1.7-1.74 c-0.67-0.35-1.13-0.78-1.42-1.11c-0.24,0.61-0.7,1.47-1.37,1.62c-0.16,0.03-0.31-0.06-0.37-0.21c0-0.01-0.03-0.1-0.09-0.36 c-0.53,0.63-1.66,1.58-3.99,2.56c-0.2,0.07-0.37,0.14-0.55,0.22l-0.09,0.03c-0.01,0.01-0.02,0.02-0.03,0.02 c-2.54,1.14-4.5,3.24-5.82,6.22c-0.77,1.72-0.87,2.82-0.98,4.48C138,103.93,138,103.94,138,103.95z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 137.84,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 138.42,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 136.69,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 137.27,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 135.55,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 136.13,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 134.41,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 134.98,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 133.26,
    className: "st16",
    width: 1.05,
    height: 0.45
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 133.84,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 132.11,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 132.69,
    className: "st16",
    width: 1.05,
    height: 0.45
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 130.97,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 131.54,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 139.04,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 139.62,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 140.24,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 140.82,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 141.44,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 142.02,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 142.64,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 143.22,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 143.84,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 144.42,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 145.05,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 145.62,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 146.24,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 146.82,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 147.44,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 148.03,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 148.65,
    className: "st16",
    width: 1.05,
    height: 0.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.16,
    y: 149.22,
    className: "st16",
    width: 1.05,
    height: 0.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.44,
    y: 149.85,
    className: "st16",
    width: 1.05,
    height: 0.41
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M151.45,116.09c-0.02-0.44-0.05-0.87-0.09-1.3l-0.02-0.2c-0.03-0.46-0.08-0.92-0.11-1.37l-0.04-0.41 c-0.03-0.39-0.07-0.78-0.11-1.16c-0.06-0.55-0.13-1.06-0.19-1.57c-0.02-0.06-0.06-0.11-0.13-0.1 c-0.07,0.01-0.11,0.06-0.11,0.12c0.02,0.46,0.05,0.96,0.09,1.58c0.02,0.39,0.05,0.78,0.09,1.17l0.03,0.4 c0.04,0.45,0.07,0.91,0.12,1.36l0.02,0.21c0.04,0.46,0.09,0.93,0.15,1.4c-0.09,0-0.18,0.01-0.28,0.01l-0.11,0.01 c-0.2,0.01-0.39,0.01-0.57,0.02c-0.07,0.01-0.12,0.06-0.12,0.12c0,0.06,0.05,0.11,0.12,0.12c0.18,0.01,0.38,0.02,0.57,0.02 h0.07c0.17,0.01,0.33,0.02,0.5,0.02h0.05l0,0c0.04,0,0.07-0.01,0.09-0.04c0.02-0.02,0.04-0.05,0.04-0.09L151.45,116.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M138.2,107.9c0.11,2.14,0.89,4.09,1.51,5.87h21.77c0.85-1.7,1.66-3.68,1.82-5.87H138.2z  M148.92,111.31c-0.72,1.19-2.12,1.77-3.21,1.83c-0.03,0-0.07,0-0.09,0c-0.01,0-0.02,0-0.03,0c-0.05,0-0.08,0-0.12,0 c-1.09-0.06-2.49-0.64-3.22-1.83c-0.04-0.07-0.07-0.15-0.08-0.22c-0.02-0.14,0-0.29,0.08-0.42 c0.34-0.55,0.83-1.01,1.42-1.34c0.57-0.33,1.24-0.51,1.91-0.51c0.7,0,1.36,0.18,1.94,0.51c0.59,0.33,1.08,0.79,1.41,1.34 c0.07,0.11,0.09,0.22,0.09,0.34C149,111.11,148.98,111.22,148.92,111.31z M159.36,111.31c-0.73,1.19-2.12,1.77-3.21,1.83 c-0.03,0-0.06,0-0.09,0c-0.01,0-0.02,0-0.02,0c-0.05,0-0.09,0-0.12,0c-0.97-0.05-2.33-0.52-3.13-1.71 c-0.03-0.04-0.05-0.08-0.08-0.11c-0.05-0.07-0.08-0.16-0.09-0.24c-0.02-0.14,0.01-0.28,0.09-0.41 c0.33-0.55,0.82-1.01,1.41-1.35c1.17-0.67,2.72-0.64,3.85,0c0.58,0.33,1.06,0.79,1.4,1.34c0.07,0.11,0.1,0.23,0.09,0.35 C159.45,111.12,159.41,111.22,159.36,111.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M161.47,114.08H139.7c-0.13,0-0.25-0.08-0.3-0.21l-0.16-0.46c-0.59-1.64-1.26-3.5-1.37-5.5 c0-0.09,0.03-0.17,0.09-0.24c0.06-0.07,0.14-0.1,0.23-0.1h25.1c0.09,0,0.18,0.03,0.24,0.1c0.06,0.07,0.09,0.15,0.09,0.24 c-0.18,2.38-1.09,4.45-1.86,5.99C161.7,114.02,161.59,114.08,161.47,114.08z M156.3,113.45h4.97 c0.69-1.39,1.45-3.2,1.68-5.23h-24.41c0.16,1.78,0.76,3.48,1.31,4.98l0.09,0.25h5.38c-1.07-0.1-2.53-0.66-3.34-1.98 c-0.07-0.1-0.11-0.22-0.13-0.34c-0.03-0.22,0.01-0.44,0.13-0.63c0.37-0.6,0.9-1.1,1.53-1.45c0.62-0.35,1.35-0.55,2.07-0.55 c0.76,0,1.46,0.19,2.1,0.55c0.62,0.35,1.15,0.86,1.52,1.45c0.09,0.16,0.14,0.34,0.13,0.53c0,0.16-0.05,0.31-0.13,0.45 c-0.8,1.32-2.26,1.88-3.34,1.98h9.9c-1.05-0.1-2.42-0.62-3.25-1.85c-0.02-0.03-0.05-0.07-0.08-0.12 c-0.08-0.11-0.12-0.24-0.13-0.38c-0.03-0.21,0.02-0.43,0.12-0.61c0.37-0.6,0.9-1.1,1.53-1.45c0.61-0.35,1.33-0.54,2.08-0.54 c0.75,0,1.48,0.19,2.09,0.54c0.62,0.36,1.15,0.86,1.52,1.45c0.1,0.16,0.14,0.35,0.13,0.54c0,0.15-0.05,0.3-0.13,0.43 C158.83,112.79,157.37,113.35,156.3,113.45z M156.02,109.15c-0.64,0-1.24,0.15-1.76,0.45c-0.54,0.3-0.99,0.73-1.3,1.24 c-0.03,0.06-0.05,0.12-0.04,0.19c0.01,0.05,0.02,0.08,0.04,0.12c0.02,0.03,0.04,0.05,0.06,0.09 c0.74,1.11,2.02,1.54,2.9,1.59c0.01,0,0.02,0,0.03,0c0.02,0,0.02,0,0.03,0c0.01,0,0.03,0,0.05,0c0.02,0,0.04,0,0.05,0 c0.02,0,0.02,0,0.04,0c1-0.04,2.3-0.59,2.96-1.68c0.03-0.04,0.04-0.08,0.04-0.13c0-0.07-0.01-0.13-0.04-0.18 c-0.31-0.5-0.76-0.93-1.3-1.23C157.28,109.3,156.65,109.15,156.02,109.15z M145.57,109.13c-0.61,0-1.23,0.16-1.75,0.46 c-0.54,0.3-0.99,0.73-1.3,1.23c-0.03,0.06-0.05,0.13-0.03,0.2c0,0.04,0.02,0.07,0.03,0.11c0.66,1.09,1.97,1.62,2.96,1.67 c0.01,0,0.02,0,0.03,0c0.01,0,0.02,0,0.04,0c0.01,0,0.03,0,0.05,0c0.03,0,0.04,0,0.05,0c0.01,0,0.02,0,0.04,0 c1-0.04,2.3-0.59,2.96-1.68c0.02-0.04,0.04-0.09,0.04-0.13c0-0.07-0.01-0.12-0.04-0.17c-0.31-0.5-0.75-0.93-1.3-1.23 C146.81,109.29,146.21,109.13,145.57,109.13z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M174.09,150.33v-13.41c0-3.04-2.48-5.51-5.51-5.51c-3.04,0-5.51,2.47-5.51,5.51v13.41H174.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M174.09,150.65h-11.02c-0.18,0-0.32-0.14-0.32-0.32v-13.41c0-3.22,2.61-5.83,5.82-5.83 c3.22,0,5.83,2.61,5.83,5.83v13.41C174.4,150.51,174.26,150.65,174.09,150.65z M163.38,150.01h10.38v-13.09 c0-2.86-2.33-5.19-5.19-5.19c-2.86,0-5.19,2.33-5.19,5.19V150.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M138.82,150.33v-13.41c0-3.04-2.47-5.51-5.51-5.51c-3.04,0-5.5,2.47-5.5,5.51v13.41H138.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M138.82,150.65h-11.02c-0.18,0-0.32-0.14-0.32-0.32v-13.41c0-3.22,2.61-5.83,5.82-5.83 c3.22,0,5.84,2.61,5.84,5.83v13.41C139.15,150.51,138.99,150.65,138.82,150.65z M128.12,150.01h10.39v-13.09 c0-2.86-2.33-5.19-5.2-5.19c-2.86,0-5.19,2.33-5.19,5.19V150.01z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "_x33__00000095332894214592807030000011159793269024032446_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M254.16,88.34l-67.55-54.56h-73.22L45.84,88.34c0,0,4.85,123.66,104.16,177.88 C249.31,212,254.16,88.34,254.16,88.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M182.5,43.82h-65L57.49,92.3l0.07,1.75c0.04,1.1,1.19,27.31,12.88,59.63 c10.82,29.94,33.12,70.75,77.88,95.19l1.68,0.91l1.68-0.91c44.76-24.44,67.06-65.25,77.89-95.19 c11.68-32.32,12.84-58.53,12.87-59.63l0.07-1.75L182.5,43.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M237.99,94.48l-57.05-46.09h-61.86L62.01,94.48c0,0,4.1,104.46,87.99,150.26 C233.89,198.94,237.99,94.48,237.99,94.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M67.95,152.97c0,1.64-1.33,2.96-2.97,2.96c-1.64,0-2.97-1.33-2.97-2.96c0-1.64,1.33-2.97,2.97-2.97 C66.62,150,67.95,151.33,67.95,152.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M237.99,152.97c0,1.64-1.32,2.96-2.96,2.96c-1.64,0-2.97-1.33-2.97-2.96c0-1.64,1.33-2.97,2.97-2.97 C236.66,150,237.99,151.33,237.99,152.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M102.35,215.78c0,1.64-1.33,2.97-2.96,2.97c-1.63,0-2.97-1.33-2.97-2.97c0-1.64,1.34-2.97,2.97-2.97 C101.02,212.81,102.35,214.14,102.35,215.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M203.59,215.78c0,1.64-1.33,2.97-2.97,2.97c-1.64,0-2.96-1.33-2.96-2.97c0-1.64,1.33-2.97,2.96-2.97 C202.26,212.81,203.59,214.14,203.59,215.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M54.77,91.65c0,1.64-1.32,2.97-2.96,2.97c-1.64,0-2.97-1.33-2.97-2.97c0-1.64,1.33-2.96,2.97-2.96 C53.44,88.69,54.77,90.02,54.77,91.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M251.16,91.65c0,1.64-1.33,2.97-2.97,2.97c-1.64,0-2.97-1.33-2.97-2.97c0-1.64,1.33-2.96,2.97-2.96 C249.84,88.69,251.16,90.02,251.16,91.65z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M152.97,258.11c0,1.63-1.33,2.96-2.97,2.96c-1.64,0-2.97-1.33-2.97-2.96c0-1.64,1.33-2.97,2.97-2.97 C151.64,255.14,152.97,256.48,152.97,258.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M118.31,38.97c0,1.64-1.33,2.97-2.97,2.97c-1.64,0-2.96-1.33-2.96-2.97c0-1.64,1.33-2.97,2.96-2.97 C116.98,36,118.31,37.33,118.31,38.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M187.63,38.97c0,1.64-1.33,2.97-2.97,2.97c-1.64,0-2.97-1.33-2.97-2.97c0-1.64,1.33-2.97,2.97-2.97 C186.29,36,187.63,37.33,187.63,38.97z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M220.4,80.25c-1.99,21.33-14.7,109.32-90.32,151.44c6.08,4.71,12.7,9.09,19.93,13.04 C233.9,198.92,238,94.46,238,94.46L220.4,80.25z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M150,76.63c-51.22,0-51.22,36.16-51.22,64.45c0,15.2,17.14,30.88,17.14,30.88l0,0v1.49v10.74v6.11 c0,4.13,3.34,7.47,7.47,7.47c4.13,0,7.48-3.35,7.48-7.47v-6.11h2.65v6.11c0,4.13,3.35,7.47,7.48,7.47c4.13,0,7.48-3.35,7.48-7.47 v-6.11h2.65v6.11c0,4.13,3.35,7.47,7.49,7.47c4.12,0,7.47-3.35,7.47-7.47v-6.11h2.66v6.11c0,4.13,3.34,7.47,7.46,7.47 c4.13,0,7.48-3.35,7.48-7.47v-6.11v-10.74v-1.28c0.13-0.07,0.26-0.14,0.39-0.21c0,0,17.14-15.68,17.14-30.88 C201.22,112.79,201.22,76.63,150,76.63z M129.18,159.68c-9.68,0-17.52-7.84-17.52-17.52c0-9.67,7.84-17.52,17.52-17.52 c9.68,0,17.52,7.84,17.52,17.52C146.7,151.83,138.86,159.68,129.18,159.68z M170.67,159.68c-9.68,0-17.52-7.84-17.52-17.52 c0-9.67,7.84-17.52,17.52-17.52c9.67,0,17.52,7.84,17.52,17.52C188.19,151.83,180.34,159.68,170.67,159.68z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "serie4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__00000119807356682233791780000008587313018635366315_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "209.42,62.1 203.28,62.1 203.28,65.03 206.06,65.03 206.06,67.18 183.96,67.18 183.96,65.03  186.88,65.03 186.88,62.1 179.97,62.1 179.97,70.17 209.42,70.17  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M252.78,88.77H47.22c-10.37,0-18.78,8.41-18.78,18.78V219.7c0,10.37,8.41,18.78,18.78,18.78h216.61 c4.28,0,7.74-3.47,7.74-7.74V107.55C271.57,97.18,263.16,88.77,252.78,88.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28.43,120.91v2.99H86.2c13.51,0,9.64-11.2,26.97-11.2H270.5c-3.63-13.77-16.17-23.93-31.08-23.93H60.58 C42.83,88.77,28.43,103.16,28.43,120.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M197.55,55.53h-36.23c-11.55,0-21.45,6.44-23.53,15.3l-7.37,31.49c-0.03,0.12,0.09,0.22,0.24,0.22h97.55 c0.15,0,0.26-0.11,0.24-0.22l-7.37-31.49C219,61.97,209.1,55.53,197.55,55.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 178.45,
    cy: 164.52,
    r: 79.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0693 174.3676)",
    className: "st21",
    cx: 178.45,
    cy: 164.52,
    rx: 75.37,
    ry: 75.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M178.45,115.52c-27.07,0-49.01,21.94-49.01,49.01c0,27.07,21.94,49.01,49.01,49.01 c27.07,0,49.01-21.94,49.01-49.01C227.45,137.46,205.51,115.52,178.45,115.52z M178.45,205.13c-22.43,0-40.6-18.18-40.6-40.6 s18.18-40.6,40.6-40.6c22.42,0,40.6,18.18,40.6,40.6S200.87,205.13,178.45,205.13z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M204.4,71v-2.01c0-4.68-3.79-8.47-8.47-8.47h-33.36c-4.68,0-8.47,3.79-8.47,8.47V71H204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M108.03,89.07H63.44c-1.2,0-2.17-0.97-2.17-2.17v-9.85c0-1.2,0.97-2.17,2.17-2.17h44.59 c1.2,0,2.17,0.97,2.17,2.17v9.85C110.19,88.1,109.22,89.07,108.03,89.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M91.42,97.75H78.03c-1.59,0-2.89,1.29-2.89,2.89v11.4c0,1.59,1.29,2.89,2.89,2.89h13.39 c1.59,0,2.89-1.29,2.89-2.89v-11.4C94.31,99.04,93.01,97.75,91.42,97.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 85.02,
    cy: 106.23,
    r: 4.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M262.83,126.01c0-2.25-1.82-4.07-4.07-4.07c-2.25,0-4.07,1.82-4.07,4.07c0,2.25,1.82,4.07,4.07,4.07 C261,130.08,262.83,128.26,262.83,126.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x32__00000147922106054825797840000015177323315411842692_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "209.42,62.1 203.28,62.1 203.28,65.03 206.06,65.03 206.06,67.18 183.96,67.18 183.96,65.03  186.88,65.03 186.88,62.1 179.97,62.1 179.97,70.17 209.42,70.17  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M252.78,88.77H47.22c-10.37,0-18.78,8.41-18.78,18.78V219.7c0,10.37,8.41,18.78,18.78,18.78h216.61 c4.28,0,7.74-3.47,7.74-7.74V107.55C271.57,97.18,263.16,88.77,252.78,88.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M28.43,120.91v2.99H86.2c13.51,0,9.64-11.2,26.97-11.2H270.5c-3.63-13.77-16.17-23.93-31.08-23.93H60.58 C42.83,88.77,28.43,103.16,28.43,120.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M197.55,55.53h-36.23c-11.55,0-21.45,6.44-23.53,15.3l-7.37,31.49c-0.03,0.12,0.09,0.22,0.24,0.22h97.55 c0.15,0,0.26-0.11,0.24-0.22l-7.37-31.49C219,61.97,209.1,55.53,197.55,55.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 178.45,
    cy: 164.52,
    r: 79.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0693 174.3676)",
    className: "st24",
    cx: 178.45,
    cy: 164.52,
    rx: 75.37,
    ry: 75.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 178.45,
    cy: 164.52,
    r: 66.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M178.45,115.52c-27.07,0-49.01,21.94-49.01,49.01c0,27.07,21.94,49.01,49.01,49.01 c27.07,0,49.01-21.94,49.01-49.01C227.45,137.46,205.51,115.52,178.45,115.52z M178.45,205.13c-22.43,0-40.6-18.18-40.6-40.6 s18.18-40.6,40.6-40.6c22.42,0,40.6,18.18,40.6,40.6S200.87,205.13,178.45,205.13z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M204.4,71v-2.01c0-4.68-3.79-8.47-8.47-8.47h-33.36c-4.68,0-8.47,3.79-8.47,8.47V71H204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M108.03,89.07H63.44c-1.2,0-2.17-0.97-2.17-2.17v-9.85c0-1.2,0.97-2.17,2.17-2.17h44.59 c1.2,0,2.17,0.97,2.17,2.17v9.85C110.19,88.1,109.22,89.07,108.03,89.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M91.42,97.75H78.03c-1.59,0-2.89,1.29-2.89,2.89v11.4c0,1.59,1.29,2.89,2.89,2.89h13.39 c1.59,0,2.89-1.29,2.89-2.89v-11.4C94.31,99.04,93.01,97.75,91.42,97.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st24",
    cx: 85.02,
    cy: 106.23,
    r: 4.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M262.83,126.01c0-2.25-1.82-4.07-4.07-4.07c-2.25,0-4.07,1.82-4.07,4.07c0,2.25,1.82,4.07,4.07,4.07 C261,130.08,262.83,128.26,262.83,126.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x33__00000035503104525096426240000010902445403783838856_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "209.42,62.1 203.28,62.1 203.28,65.03 206.06,65.03 206.06,67.18 183.96,67.18 183.96,65.03  186.88,65.03 186.88,62.1 179.97,62.1 179.97,70.17 209.42,70.17  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M252.78,88.77H47.22c-10.37,0-18.78,8.41-18.78,18.78V219.7c0,10.37,8.41,18.78,18.78,18.78h216.61 c4.28,0,7.74-3.47,7.74-7.74V107.55C271.57,97.18,263.16,88.77,252.78,88.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M28.43,120.91v2.99H86.2c13.51,0,9.64-11.2,26.97-11.2H270.5c-3.63-13.77-16.17-23.93-31.08-23.93H60.58 C42.83,88.77,28.43,103.16,28.43,120.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M197.55,55.53h-36.23c-11.55,0-21.45,6.44-23.53,15.3l-7.37,31.49c-0.03,0.12,0.09,0.22,0.24,0.22h97.55 c0.15,0,0.26-0.11,0.24-0.22l-7.37-31.49C219,61.97,209.1,55.53,197.55,55.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 178.45,
    cy: 164.52,
    r: 79.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0693 174.3676)",
    className: "st28",
    cx: 178.45,
    cy: 164.52,
    rx: 75.37,
    ry: 75.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M178.45,115.52c-27.07,0-49.01,21.94-49.01,49.01c0,27.07,21.94,49.01,49.01,49.01 c27.07,0,49.01-21.94,49.01-49.01C227.45,137.46,205.51,115.52,178.45,115.52z M178.45,205.13c-22.43,0-40.6-18.18-40.6-40.6 s18.18-40.6,40.6-40.6c22.42,0,40.6,18.18,40.6,40.6S200.87,205.13,178.45,205.13z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M204.4,71v-2.01c0-4.68-3.79-8.47-8.47-8.47h-33.36c-4.68,0-8.47,3.79-8.47,8.47V71H204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M108.03,89.07H63.44c-1.2,0-2.17-0.97-2.17-2.17v-9.85c0-1.2,0.97-2.17,2.17-2.17h44.59 c1.2,0,2.17,0.97,2.17,2.17v9.85C110.19,88.1,109.22,89.07,108.03,89.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M91.42,97.75H78.03c-1.59,0-2.89,1.29-2.89,2.89v11.4c0,1.59,1.29,2.89,2.89,2.89h13.39 c1.59,0,2.89-1.29,2.89-2.89v-11.4C94.31,99.04,93.01,97.75,91.42,97.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st28",
    cx: 85.02,
    cy: 106.23,
    r: 4.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M262.83,126.01c0-2.25-1.82-4.07-4.07-4.07c-2.25,0-4.07,1.82-4.07,4.07c0,2.25,1.82,4.07,4.07,4.07 C261,130.08,262.83,128.26,262.83,126.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x34__00000004511210753720722740000011756294957678535853_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "209.42,62.1 203.28,62.1 203.28,65.03 206.06,65.03 206.06,67.18 183.96,67.18 183.96,65.03  186.88,65.03 186.88,62.1 179.97,62.1 179.97,70.17 209.42,70.17  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M252.78,88.77H47.22c-10.37,0-18.78,8.41-18.78,18.78V219.7c0,10.37,8.41,18.78,18.78,18.78h216.61 c4.28,0,7.74-3.47,7.74-7.74V107.55C271.57,97.18,263.16,88.77,252.78,88.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M28.43,120.91v2.99H86.2c13.51,0,9.64-11.2,26.97-11.2H270.5c-3.63-13.77-16.17-23.93-31.08-23.93H60.58 C42.83,88.77,28.43,103.16,28.43,120.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M197.55,55.53h-36.23c-11.55,0-21.45,6.44-23.53,15.3l-7.37,31.49c-0.03,0.12,0.09,0.22,0.24,0.22h97.55 c0.15,0,0.26-0.11,0.24-0.22l-7.37-31.49C219,61.97,209.1,55.53,197.55,55.53z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st35",
    cx: 178.45,
    cy: 164.52,
    r: 79.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -64.0693 174.3676)",
    className: "st30",
    cx: 178.45,
    cy: 164.52,
    rx: 75.37,
    ry: 75.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M178.45,115.52c-27.07,0-49.01,21.94-49.01,49.01c0,27.07,21.94,49.01,49.01,49.01 c27.07,0,49.01-21.94,49.01-49.01C227.45,137.46,205.51,115.52,178.45,115.52z M178.45,205.13c-22.43,0-40.6-18.18-40.6-40.6 s18.18-40.6,40.6-40.6c22.42,0,40.6,18.18,40.6,40.6S200.87,205.13,178.45,205.13z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M204.4,71v-2.01c0-4.68-3.79-8.47-8.47-8.47h-33.36c-4.68,0-8.47,3.79-8.47,8.47V71H204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M108.03,89.07H63.44c-1.2,0-2.17-0.97-2.17-2.17v-9.85c0-1.2,0.97-2.17,2.17-2.17h44.59 c1.2,0,2.17,0.97,2.17,2.17v9.85C110.19,88.1,109.22,89.07,108.03,89.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M91.42,97.75H78.03c-1.59,0-2.89,1.29-2.89,2.89v11.4c0,1.59,1.29,2.89,2.89,2.89h13.39 c1.59,0,2.89-1.29,2.89-2.89v-11.4C94.31,99.04,93.01,97.75,91.42,97.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 85.02,
    cy: 106.23,
    r: 4.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M262.83,126.01c0-2.25-1.82-4.07-4.07-4.07c-2.25,0-4.07,1.82-4.07,4.07c0,2.25,1.82,4.07,4.07,4.07 C261,130.08,262.83,128.26,262.83,126.01z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "serie5",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__00000076604153691011090720000005506057049216493240_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.88,159.06c0-26.99-21.89-48.87-48.88-48.87c-26.99,0-48.88,21.89-48.88,48.87 c0,27,21.89,48.88,48.88,48.88C177,207.94,198.88,186.06,198.88,159.06z M133.84,152.93c-7.9,0-14.29-6.39-14.29-14.29 c0-7.88,6.4-14.28,14.29-14.28c7.88,0,14.29,6.4,14.29,14.28C148.13,146.54,141.73,152.93,133.84,152.93z M162.5,144.17 c-3.87,0-7-3.14-7-7.01c0-3.87,3.13-7.01,7-7.01c3.87,0,7.01,3.13,7.01,7.01C169.51,141.02,166.38,144.17,162.5,144.17z  M273.9,223.3c-4.09,12.98-14.89,22.27-27.62,22.27H53.72c-12.73,0-23.54-9.29-27.62-22.27H273.9z M246.28,82.43h-28.36 l-24.5-28.01H150h-43.41l-24.5,28.01H53.72c-16.24,0-29.4,15.1-29.4,33.71v93.4h86.92c-15.15-11.64-24.93-29.9-24.93-50.47 c0-35.18,28.51-63.69,63.69-63.69c35.19,0,63.7,28.52,63.7,63.69c0,20.58-9.78,38.83-24.94,50.47h86.92v-93.4 C275.68,97.53,262.52,82.43,246.28,82.43z M53.19,114.26h-5.56c-5.44,0-9.84-4.41-9.84-9.84c0-5.43,4.41-9.84,9.84-9.84h5.56 c5.44,0,9.85,4.41,9.85,9.84C63.03,109.85,58.63,114.26,53.19,114.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x32__00000089566828199487480420000011115924892793669019_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.88,159.06c0-26.99-21.89-48.87-48.88-48.87c-26.99,0-48.88,21.89-48.88,48.87 c0,27,21.89,48.88,48.88,48.88C177,207.94,198.88,186.06,198.88,159.06z M133.84,152.93c-7.9,0-14.29-6.39-14.29-14.29 c0-7.88,6.4-14.28,14.29-14.28c7.88,0,14.29,6.4,14.29,14.28C148.13,146.54,141.73,152.93,133.84,152.93z M162.5,144.17 c-3.87,0-7-3.14-7-7.01c0-3.87,3.13-7.01,7-7.01c3.87,0,7.01,3.13,7.01,7.01C169.51,141.02,166.38,144.17,162.5,144.17z  M273.9,223.3c-4.09,12.98-14.89,22.27-27.62,22.27H53.72c-12.73,0-23.54-9.29-27.62-22.27H273.9z M246.28,82.43h-28.36 l-24.5-28.01H150h-43.41l-24.5,28.01H53.72c-16.24,0-29.4,15.1-29.4,33.71v93.4h86.92c-15.15-11.64-24.93-29.9-24.93-50.47 c0-35.18,28.51-63.69,63.69-63.69c35.19,0,63.7,28.52,63.7,63.69c0,20.58-9.78,38.83-24.94,50.47h86.92v-93.4 C275.68,97.53,262.52,82.43,246.28,82.43z M53.19,114.26h-5.56c-5.44,0-9.84-4.41-9.84-9.84c0-5.43,4.41-9.84,9.84-9.84h5.56 c5.44,0,9.85,4.41,9.85,9.84C63.03,109.85,58.63,114.26,53.19,114.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33__00000029758477281962540150000010503105465009729947_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M198.88,159.06c0-26.99-21.89-48.87-48.88-48.87c-26.99,0-48.88,21.89-48.88,48.87 c0,27,21.89,48.88,48.88,48.88C177,207.94,198.88,186.06,198.88,159.06z M133.84,152.93c-7.9,0-14.29-6.39-14.29-14.29 c0-7.88,6.4-14.28,14.29-14.28c7.88,0,14.29,6.4,14.29,14.28C148.13,146.54,141.73,152.93,133.84,152.93z M162.5,144.17 c-3.87,0-7-3.14-7-7.01c0-3.87,3.13-7.01,7-7.01c3.87,0,7.01,3.13,7.01,7.01C169.51,141.02,166.38,144.17,162.5,144.17z  M273.9,223.3c-4.09,12.98-14.89,22.27-27.62,22.27H53.72c-12.73,0-23.54-9.29-27.62-22.27H273.9z M246.28,82.43h-28.36 l-24.5-28.01H150h-43.41l-24.5,28.01H53.72c-16.24,0-29.4,15.1-29.4,33.71v93.4h86.92c-15.15-11.64-24.93-29.9-24.93-50.47 c0-35.18,28.51-63.69,63.69-63.69c35.19,0,63.7,28.52,63.7,63.69c0,20.58-9.78,38.83-24.94,50.47h86.92v-93.4 C275.68,97.53,262.52,82.43,246.28,82.43z M53.19,114.26h-5.56c-5.44,0-9.84-4.41-9.84-9.84c0-5.43,4.41-9.84,9.84-9.84h5.56 c5.44,0,9.85,4.41,9.85,9.84C63.03,109.85,58.63,114.26,53.19,114.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x34__00000018228533480963221170000014436646577457946262_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M198.88,159.06c0-26.99-21.89-48.87-48.88-48.87c-26.99,0-48.88,21.89-48.88,48.87 c0,27,21.89,48.88,48.88,48.88C177,207.94,198.88,186.06,198.88,159.06z M133.84,152.93c-7.9,0-14.29-6.39-14.29-14.29 c0-7.88,6.4-14.28,14.29-14.28c7.88,0,14.29,6.4,14.29,14.28C148.13,146.54,141.73,152.93,133.84,152.93z M162.5,144.17 c-3.87,0-7-3.14-7-7.01c0-3.87,3.13-7.01,7-7.01c3.87,0,7.01,3.13,7.01,7.01C169.51,141.02,166.38,144.17,162.5,144.17z  M273.9,223.3c-4.09,12.98-14.89,22.27-27.62,22.27H53.72c-12.73,0-23.54-9.29-27.62-22.27H273.9z M246.28,82.43h-28.36 l-24.5-28.01H150h-43.41l-24.5,28.01H53.72c-16.24,0-29.4,15.1-29.4,33.71v93.4h86.92c-15.15-11.64-24.93-29.9-24.93-50.47 c0-35.18,28.51-63.69,63.69-63.69c35.19,0,63.7,28.52,63.7,63.69c0,20.58-9.78,38.83-24.94,50.47h86.92v-93.4 C275.68,97.53,262.52,82.43,246.28,82.43z M53.19,114.26h-5.56c-5.44,0-9.84-4.41-9.84-9.84c0-5.43,4.41-9.84,9.84-9.84h5.56 c5.44,0,9.85,4.41,9.85,9.84C63.03,109.85,58.63,114.26,53.19,114.26z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNegative);
export default __webpack_public_path__ + "static/media/face-negative.fbfb78133443f30ec7349b930c237ed5.svg";
export { ForwardRef as ReactComponent };